'use client';
import { useState, useCallback } from 'react';

interface UseModal {
	isOpen: (id: string) => boolean;
	onOpen: (id: string) => void;
	onClose: (id: string) => void;
	toggle: (id: string) => void;
}

const useModal = (): UseModal => {
	const [openModals, setOpenModals] = useState<Record<string, boolean>>({});

	const onOpen = useCallback((id: string) => {
		setOpenModals((prev) => ({ ...prev, [id]: true }));
	}, []);

	const onClose = useCallback((id: string) => {
		setOpenModals((prev) => ({ ...prev, [id]: false }));
	}, []);

	const toggle = useCallback((id: string) => {
		setOpenModals((prev) => ({ ...prev, [id]: !prev[id] }));
	}, []);

	const isOpen = useCallback(
		(id: string) => {
			return !!openModals[id];
		},
		[openModals]
	);

	return { isOpen, onOpen, onClose, toggle };
};

export default useModal;
